import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import Button from "../../../components/ui/Button/Button";
import FieldBox from "../../../utils/Form/ui/FieldBox";
import { Dropdown } from "../../../components/ui/Dropdown/Dropdown";
import InputDate from "../../../components/ui/InputDate/InputDate";
import {
  addNotification,
  useAddNotification,
} from "../../../api/notification/use-push-notification";
import { Form } from "../../../utils/Form/Form";
import dayjs from "dayjs";
import InputTime from "../../../components/ui/InputTime/InputTime";
import Modal from "../../../components/ui/Modal/Modal";
import SelectRecipient from "../Components/SelectRecipient";
import { getNotificationsTargets } from "../../../api/notifications";

const options = [
  { id: "all", name: "전체 병원회원" },
  { id: "noAll", name: "지정 병원회원" },
];

const ManualShipping = () => {
  const [isRegister, setIsRegister] = useState(false);
  const [immediate, setImmediate] = useState(false);
  const [reservation, setReservation] = useState(false);
  const [isShowAssignButton, setIsShowAssignButton] = useState(false);
  const [url, setUrl] = useState(false);
  const [noneUrl, setNoneUrl] = useState(false);
  const [dateValue, setDateValue] = useState("");
  const [scheduleDate, setScheduleDate] = useState("");
  const [scheduleTime, setScheduleTime] = useState("");
  const [recipient, setRecipient] = useState([]);
  const [triggerCloseModal, setTriggerCloseModal] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [inputValue, setInputValue] = useState({
    title: "",
    content: "",
    sendToAll: true,
    scheduleTime: null,
  });

  const { data: notificationsTagets } = useQuery({
    queryKey: ["notifications-targets"],
    queryFn: getNotificationsTargets,
  });

  useEffect(() => {
    if (triggerCloseModal === true) {
      setTriggerCloseModal(false);
    }
  }, [triggerCloseModal]);

  const handleInputChange = (e, nameForm) => {
    const value = e.target.value;
    if (nameForm === "title" && value.length <= 40) {
      setInputValue({ ...inputValue, [nameForm]: value });
    }
    if (nameForm === "content" && value.length <= 500) {
      setInputValue({ ...inputValue, [nameForm]: value });
    }
    if (nameForm !== "title" && nameForm !== "content") {
      setInputValue({ ...inputValue, [nameForm]: value });
    }
  };

  const onChangeDateValue = (value) => {
    const date = dayjs(value)?.format("YYYY-MM-DD");
    setDateValue(value);
    setScheduleDate(date);
  };

  const handleReservation = () => {
    setReservation(true);
    setImmediate(false);
  };

  const handleImmediate = () => {
    setImmediate(true);
    setReservation(false);
  };

  const handleUrl = () => {
    setUrl(true);
    setNoneUrl(false);
  };

  const handleNoneUrl = () => {
    setUrl(false);
    setNoneUrl(true);
    delete inputValue["externalLink"];
  };

  const handleRegister = () => {
    setIsRegister(true);
  };

  const onChangeDestination = (id) => {
    if (id === "noAll") {
      setIsShowAssignButton(true);
    } else {
      setIsShowAssignButton(false);
    }
    setInputValue({
      ...inputValue,
      sendToAll: id === "all" ? true : false,
    });
  };

  const handleSubmit = async () => {
    const dateTime = dayjs(`${scheduleDate} ${scheduleTime}`);
    const sched = dateTime.isValid() ? dateTime.toDate().toISOString() : null;

    const payload = {
      ...inputValue,
      scheduleTime: sched,
    };

    const payloadWithRecipient = {
      ...inputValue,
      scheduleTime: sched,
      receiverIds: recipient?.map((res) => res?.id),
    };

    const res = await addNotification(
      inputValue?.sendToAll === true ? payload : payloadWithRecipient
    );
    if (res?.status === 200) {
      setIsSuccess(true);
      setIsRegister(false);
      setInputValue({
        title: "",
        content: "",
        sendToAll: true,
        scheduleTime: null,
      });
      setImmediate(false);
      setReservation(false);
      setNoneUrl(false);
      setUrl(false);
      setRecipient([]);
    }
  };

  const onCancel = () => {
    setInputValue({
      title: "",
      content: "",
      sendToAll: true,
      scheduleTime: null,
    });
    setImmediate(false);
    setReservation(false);
    setNoneUrl(false);
    setUrl(false);
    setRecipient([]);
    setIsRegister(false);
  };

  return (
    <div>
      {isRegister ? (
        <div className="-mt-2">
          <Form>
            {({ register, watch, reset }) => {
              const checkIsEmpty = ({ sendToAll, ...obj }) =>
                Object.values(obj).some(
                  (val) => val === "" || val === undefined
                );
              return (
                <>
                  <FieldBox label="발송 유형">
                    <div className="px-2 flex gap-4 h-6">
                      <div className="flex items-center">
                        <input
                          id="type1"
                          type="radio"
                          name="radio"
                          onChange={handleImmediate}
                          checked={immediate}
                          className="mr-2 accent-black"
                        />
                        <label htmlFor="type1">즉시 발송</label>
                      </div>
                      <div className="flex items-center">
                        <input
                          id="type2"
                          type="radio"
                          name="radio"
                          onChange={handleReservation}
                          checked={reservation}
                          className="mr-2 accent-black"
                        />
                        <label htmlFor="type2">예약 발송</label>
                      </div>
                      {reservation === true ? (
                        <div className="flex items-center">
                          <InputDate
                            onChange={onChangeDateValue}
                            value={dateValue}
                          />{" "}
                          <span className="text-secondary-grey mx-2">-</span>{" "}
                          <InputTime
                            time={scheduleTime}
                            setTime={setScheduleTime}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </FieldBox>
                  <FieldBox label="발송 대상">
                    <div className="">
                      <div className="flex ml-2 items-center">
                        <Dropdown
                          defaultValue="all"
                          textColor="text-black"
                          dropdownWidth="w-40"
                          positionDropdown={`top-10`}
                          width="w-40"
                          options={options}
                          onClickItem={(id) => onChangeDestination(id)}
                        />
                        {isShowAssignButton ? (
                          <Modal
                            hasClose={true}
                            maxWidth="max-w-[38rem]"
                            description={
                              <SelectRecipient
                                recipient={recipient}
                                setRecipient={setRecipient}
                                setTriggerCloseModal={setTriggerCloseModal}
                              />
                            }
                            hasCancel={false}
                            hasSubmit={false}
                            title="수신 대상자 선택"
                            padding="py-4"
                            paddingTitle={`px-6`}
                            triggerClose={triggerCloseModal}
                          >
                            <button
                              type="button"
                              className={`bg-gradient-to-b from-white via-primary-white to-background-grey border border-button-grey px-3 py-1 rounded-[4px] ml-2`}
                            >
                              대상선택
                            </button>
                          </Modal>
                        ) : null}
                        <span className="text-secondary-red ml-2 font-bold">
                          발송 대상 : 총{" "}
                          {inputValue?.sendToAll === true
                            ? notificationsTagets?.data.length ?? 0
                            : recipient?.length}
                          명
                        </span>
                      </div>
                      {inputValue?.sendToAll === false &&
                      recipient?.length > 0 ? (
                        <div className="text-black -mx-2 -mb-2 mt-2 py-2 px-4 bg-[#EDEDED] h-20">
                          {/* 지정 병원회원의 '대상선택'을 해주세요 */}
                          {recipient?.map((res, index) => {
                            return (
                              <span>
                                {res?.email}
                                {index < recipient?.length - 1 ? ", " : ""}
                              </span>
                            );
                          })}
                        </div>
                      ) : null}
                      {inputValue?.sendToAll === false &&
                      recipient?.length === 0 ? (
                        <div className="text-title-grey -mx-2 -mb-2 mt-2 py-2 px-4 bg-[#EDEDED] h-20">
                          지정 병원회원의 '대상선택'을 해주세요
                        </div>
                      ) : null}
                    </div>
                  </FieldBox>
                  <FieldBox label={`제목 (${inputValue?.title?.length}/40)`}>
                    <input
                      type="text"
                      onChange={(e) => handleInputChange(e, "title")}
                      placeholder="공백포함 40자이내 입력해주세요."
                      className="w-full px-2 outline-none placeholder:text-[12px]"
                      value={inputValue.title}
                    />
                  </FieldBox>
                  <FieldBox
                    label={
                      <div>
                        내용
                        <br />({inputValue?.content?.length}/500)
                      </div>
                    }
                  >
                    <textarea
                      placeholder="- 500자까지 입력 가능합니다.&#13;&#10;- 줄바꿈 사용 시 그대로 적용됩니다.&#13;&#10;- 광고성 알림 발송의 경우, (광고)표시가 필수입니다."
                      cols="10"
                      className="w-full p-2 outline-none text-[11px] resize-none"
                      rows="7"
                      onChange={(e) => handleInputChange(e, "content")}
                      value={inputValue.content}
                    ></textarea>
                  </FieldBox>
                  <FieldBox isLast label="연결 외부 URL">
                    <div className="px-2 flex gap-4 h-6">
                      <div className="flex items-center">
                        <input
                          type="radio"
                          name="radio2"
                          onChange={handleNoneUrl}
                          id="noUrl"
                          className="mr-2 accent-black"
                          checked={noneUrl}
                        />
                        <label htmlFor="noUrl">없음</label>
                      </div>
                      <div className="flex items-center">
                        <input
                          type="radio"
                          name="radio2"
                          onChange={handleUrl}
                          checked={url}
                          id="withUrl"
                          className="mr-2 accent-black"
                        />
                        <label htmlFor="withUrl">연결 외부 URL 입력</label>
                      </div>
                      {url && (
                        <div className="-mt-1 -ml-2 w-[78%]">
                          <input
                            placeholder="외부로 연결할 URL을 입력해주세요."
                            className="p-1.5 w-full border outline-none border-border-grey rounded-[4px]"
                            type="text"
                            onChange={(e) =>
                              handleInputChange(e, "externalLink")
                            }
                          />
                        </div>
                      )}
                    </div>
                  </FieldBox>
                  <div className="flex justify-center mt-12">
                    <Modal
                      description="입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다."
                      onSubmit={onCancel}
                    >
                      <Button
                        type="button"
                        className="py-[8.5px]"
                        paddingButton="p-3"
                        text={`입력취소`}
                      />
                    </Modal>
                    <Modal
                      description="입력하신 정보로 발송하시겠습니까? 예약발송의 경우, 발송내역에서 발송
                    할 날짜이전에 ‘발송취소’가 가능합니다."
                      onSubmit={handleSubmit}
                    >
                      <Button
                        onClick={(e) => e.preventDefault()}
                        type="submit"
                        className="py-[8.5px]"
                        text={`등록완료`}
                        primary
                        isDisabled={
                          checkIsEmpty(inputValue) ||
                          (immediate === false && reservation === false) ||
                          (url === false && noneUrl === false)
                        }
                      />
                    </Modal>
                  </div>
                </>
              );
            }}
          </Form>
        </div>
      ) : (
        <Button
          onClick={handleRegister}
          text={`푸시알림 발송 등록`}
          bgColor="bg-primary-blue"
          textColorDefault="text-white"
          className={`py-2.5`}
          width="w-[100%]"
        />
      )}
    </div>
  );
};

export default ManualShipping;
